import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import {
  getCoverDeviation,
  getCoverDeviationOffsetY,
} from '../../../selectors/deviations';

const mapStateToProps = (state: AppState) => {
  const coverDeviation = getCoverDeviation(state);
  const coverDeviationidOffsetY = getCoverDeviationOffsetY(state);
  return {
    coverDeviation,
    coverDeviationidOffsetY,
  };
};

export default connect(
  mapStateToProps,
  {}
);
